export var widgetUrl = 'https://conversional-staging-v3.appspot.com';
